import { red } from '../../Constants/Colors';
import { makeStyles } from '@material-ui/core/styles';

const menuItemBeforeStyle = {
  content: '""',
  position: 'absolute',
  width: 0,
  height: 4,
  bottom: -4,
  left: 0,
  backgroundColor: red,
  visibility: 'hidden',
  transition: 'all .25s',
};

const menuItemBeforeStyleActive = {
  visibility: 'visible',
  width: '100%',
};

export const useStyles = makeStyles(() => ({
  root: {
    paddingBottom: '1rem',
  },
  listRoot: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  redText: {
    color: red,
    marginLeft: '0.9rem',
  },
  listText: {
    cursor: 'pointer',
    '& > span': {
      color: 'white',
      fontWeight: 'bolder',
      display: 'inline',
      position: 'relative',
      '&:before': {
        ...menuItemBeforeStyle,
      },
    },
    '&.inactive': {
      cursor: 'default',
    },
  },
  listItem: {
    width: 'auto',
    marginRight: 'min(50px, 5%)',
    '&:hover:not([disabled]), &.Mui-selected': {
      backgroundColor: 'transparent',
      '& $listText > span:before': {
        ...menuItemBeforeStyleActive,
      },
    },
  },
}));
